import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import { buildAccountUrl } from '../../../app/services';
import { useCallback, useState } from 'react';
import { GlobalLoading } from '../../../common/components/GlobalLoading';
import { getPageTitle } from '../../../common/utils/pageUtils';
import { useGetSignatureFollowupPdfFileTokenQuery } from '../../../app/services/account';
import { skipToken } from '@reduxjs/toolkit/dist/query';

export default function ClinicalFollowUpsSignatureContenrPage() {
  const { t } = useTranslation();
  const { clinicalAccountId, reportName } = useParams();
  const [reportLoaded, setReportLoaded] = useState(false);
  const onLoad = useCallback(() => {
    setReportLoaded(true);
  }, []);
  const { data: reportTokenRes } = useGetSignatureFollowupPdfFileTokenQuery(
    clinicalAccountId && reportName ? {
      clinicAccountId: clinicalAccountId,
      } : skipToken
  );
  return (
    <Box>
      <Helmet>
        <title>{getPageTitle(t('patientReport.title'))}</title>
      </Helmet>
      {!reportLoaded && <GlobalLoading appBarHeight={0} loadingText={t('account.manageAccounts.accountForm.clinicalFollowUps.signatureForm.generatingSignFollowup')} />}
      {clinicalAccountId && reportName && reportTokenRes?.token && (
        <iframe
          onLoad={onLoad}
          title={reportName}
          src={`${buildAccountUrl(
            '/v1/account/clinical-followup-signature/download-signature-followup'
          )}?clinicAccountId=${clinicalAccountId}&token=${reportTokenRes?.token}`}
          style={{ height: '100vh', width: '100%' }}
        ></iframe>
      )}
    </Box>
  );
}
